export const DEFAULT_FORMAT = 'ddd DD MMM YYYY HH:mm'
export const CONTRACT_FORMAT = 'DD.MM.YYYY'
export const ISO_FORMAT = 'DD.MM.YYYY'
export const PRODUCT_FORMAT = 'DD MMM YYYY HH:mm'
export const NEWS_FORMAT = 'DD.MM.YYYY HH:mm'
export const HISTORY_FORMAT = 'dddd DD.MM.YYYY HH:mm'
